import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, QueryList, ViewChildren, ElementRef } from '@angular/core';

import { ModalDialogService } from './modal-dialog.service';

@Component({
	selector: 'qe-modal-dialog',
	standalone: true,
	imports: [CommonModule],
	templateUrl: './modal-dialog.component.html',
	styleUrls: ['./modal-dialog.component.scss']
})
export class ModalDialogComponent implements AfterViewInit {
	@ViewChildren('nativeDialog') dialogs!: QueryList<ElementRef<HTMLDialogElement>>;

	constructor(public dialogService: ModalDialogService) { }

	ngAfterViewInit(): void {
		this.dialogs.changes.subscribe(() => {
			queueMicrotask(() => { this.ensureAllShown(); });
		});
		queueMicrotask(() => { this.ensureAllShown(); });
	}

	onCancel(ref: { close: () => void }, ev: Event): void {
		ev.preventDefault();
		ref.close();
	}

	onDialogClick(ev: MouseEvent, ref: { close: () => void; _notifyBackdropClick?: (e: MouseEvent) => void }): void {
		const dialogEl = ev.currentTarget as HTMLDialogElement;
		if (ev.target === dialogEl) {
			ref._notifyBackdropClick?.(ev);
			ref.close();
		}
	}

	trackById(_: number, item: { id: number }): number { return item.id; }

	private ensureAllShown(): void {
		this.dialogs.forEach(ref => {
			const dlg = ref.nativeElement as HTMLDialogElement & { _shown?: boolean; showModal?: () => void };
			if (!dlg._shown) {
				dlg.showModal?.();
				dlg._shown = true;
			}
		});
	}
}
